import { createContext, ReactNode, useContext } from 'react';

export type AuthoredTeamMembersContextValue = {
  dialogTitle: string;
  noItemsSelectedMessage: string;
  successMessage: string;
  buttonLabel: string;
  removeMemberSuccessMessage: string;
  createSubteamDialogTitle: string;
  createSubteamSuccessMessage: string;
  createSubteamButtonLabel: string;
  deleteTeamDialogTitle: string;
  deleteTeamSuccessMessage: string;
  deleteTeamButtonLabel: string;
  renameTeamDialogTitle: string;
  renameTeamSuccessMessage: string;
  renameTeamButtonLabel: string;
};

export type TeamMembersContextValue = {
  onClick: (teamId: string) => void;
  refreshTeamsSummary: () => void;
} & AuthoredTeamMembersContextValue;

const TeamMembersContext = createContext<TeamMembersContextValue>({} as TeamMembersContextValue);

export default ({ children, value }: { children: ReactNode; value: TeamMembersContextValue }) => (
  <TeamMembersContext.Provider value={value}>{children}</TeamMembersContext.Provider>
);

export const useTeamMembersContext = () => useContext(TeamMembersContext);
